import { Entity, Exam, User } from '../../types';
import { FormEntry } from '../forms/types';

export enum ExamFormType {
  EXAMINER = 'examiner',
  DELEGATE = 'delegate',
  ASPIRANT = 'aspirant',
}

export const ExamFormTypes: Record<string, string> = {
  [ExamFormType.EXAMINER]: 'Examinatorrapport',
  [ExamFormType.DELEGATE]: 'Gedelegeerdenrapport',
  [ExamFormType.ASPIRANT]: 'Aspiranten beoordelingsrapport',
};

export enum ExamFormState {
  OPEN = 'open',
  IN_REVIEW = 'in_review',
  FINALIZED = 'finalized',
}

export enum ExamFormGrade {
  SUFFICIENT = 'sufficient',
  INSUFFICIENT = 'insufficient',
  ATTENTION = 'attention',
  TERMINATED = 'terminated',
}

export const ExamFormGrades: Record<string, string> = {
  [ExamFormGrade.SUFFICIENT]: 'Voldoende',
  [ExamFormGrade.INSUFFICIENT]: 'Onvoldoende',
  [ExamFormGrade.ATTENTION]: 'Extra aandacht',
  [ExamFormGrade.TERMINATED]: 'Stopt',
};

export const AvailableExamFormGradesForType: Record<string, ExamFormGrade[]> = {
  [ExamFormType.EXAMINER]: [
    ExamFormGrade.SUFFICIENT,
    ExamFormGrade.INSUFFICIENT,
    ExamFormGrade.ATTENTION,
  ],
  [ExamFormType.DELEGATE]: [
    ExamFormGrade.SUFFICIENT,
    ExamFormGrade.INSUFFICIENT,
    ExamFormGrade.ATTENTION,
  ],
  [ExamFormType.ASPIRANT]: [
    ExamFormGrade.SUFFICIENT,
    ExamFormGrade.INSUFFICIENT,
    ExamFormGrade.TERMINATED,
  ],
};

export interface ExamFormEntry extends Entity {
  type: ExamFormType;
  formEntry: FormEntry;
  state: ExamFormState;
  grade: ExamFormGrade | null;
  creator: User;
}

// maps exam form types to the corresponding field in the exam object
export const EXAM_FORM_TYPE_TO_EXAM_FIELD_MAPPING: Record<
  ExamFormType,
  keyof Pick<
    Exam,
    'examinerFormEntry' | 'delegateFormEntry' | 'aspirantFormEntry'
  >
> = {
  [ExamFormType.EXAMINER]: 'examinerFormEntry',
  [ExamFormType.DELEGATE]: 'delegateFormEntry',
  [ExamFormType.ASPIRANT]: 'aspirantFormEntry',
};
